/**
 * Delivery note exposed to the dentist portal. Mirrors a shipment
 * but anonymised to the patient reference and with an optional
 * signed PDF URL produced by the back-end on demand.
 */

export const DeliveryNoteStatus = {
  Pending: 'pending',
  Shipped: 'shipped',
  Delivered: 'delivered',
} as const;
export type DeliveryNoteStatus = (typeof DeliveryNoteStatus)[keyof typeof DeliveryNoteStatus];

export const ALL_DELIVERY_NOTE_STATUSES: readonly DeliveryNoteStatus[] = [
  DeliveryNoteStatus.Pending,
  DeliveryNoteStatus.Shipped,
  DeliveryNoteStatus.Delivered,
];

export const DELIVERY_NOTE_STATUS_LABELS: Readonly<Record<DeliveryNoteStatus, string>> = {
  [DeliveryNoteStatus.Pending]: 'Pending',
  [DeliveryNoteStatus.Shipped]: 'Shipped',
  [DeliveryNoteStatus.Delivered]: 'Delivered',
};

export interface DeliveryNote {
  readonly id: string;
  readonly deliveryNoteNumber: string;
  readonly orderId: string | null;
  readonly clientId: string | null;
  readonly deliveryDate: string;
  readonly description: string | null;
  readonly status: DeliveryNoteStatus;
  /** Short display number from the client-portal API (null for lab-facing notes). */
  readonly number: string | null;
  readonly patientRef: string | null;
  readonly carrier: string | null;
  readonly trackingNumber: string | null;
  readonly shippedAt: string | null;
  readonly deliveredAt: string | null;
  readonly pdfUrl: string | null;
}
